import { render } from "./monitorplay.vue?vue&type=template&id=05a96228&scoped=true&ts=true"
import script from "./monitorplay.vue?vue&type=script&lang=ts"
export * from "./monitorplay.vue?vue&type=script&lang=ts"

import "./monitorplay.vue?vue&type=style&index=0&id=05a96228&lang=scss&scoped=true"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05a96228"]])

export default __exports__